import { render, staticRenderFns } from "./scalingExpertInfo_detail.vue?vue&type=template&id=690ab4a6&scoped=true"
import script from "./scalingExpertInfo_detail.vue?vue&type=script&lang=js"
export * from "./scalingExpertInfo_detail.vue?vue&type=script&lang=js"
import style0 from "./scalingExpertInfo_detail.vue?vue&type=style&index=0&id=690ab4a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690ab4a6",
  null
  
)

export default component.exports